const Operators = [
    {
        id: 1,
        title: "The Eagle Safaris",
        image: "https://www.walkintothewild.in/storage/safarioperator/3/safarioperator1724330309.jpeg",
        review: "1 Reviwes",
        features: [
            { icon: "fa-solid fa-star", icon1: "fa-solid fa-star", icon2: "fa-solid fa-star", icon3: "fa-solid fa-star", icon4: "fa-solid fa-star" },
            
        ],
        footerfeatures: [
           { number: "15",  text: "Parks" },
           { number: "12", text: "Packages" },
           { number: "0", text: "Shared Safari" },
        ],
    },
    {
        id: 2,
        title: "Epic Escapes",
        image: "https://www.walkintothewild.in/storage/safarioperator/79/safarioperator1725195798.jpg",
        review: "0 Reviwes",
        features: [
            { icon: "fa-solid fa-star", icon1: "fa-solid fa-star", icon2: "fa-solid fa-star", icon3: "fa-solid fa-star", icon4: "fa-solid fa-star" },
            
        ],
        footerfeatures: [
           { number: "16",  text: "Parks" },
           { number: "10", text: "Packages" },
           { number: "0", text: "Shared Safari" },
        ],
    },
    {
        id: 3,
        title: "Cultural Safari Tours",
        image: "https://www.walkintothewild.in/storage/safarioperator/17/safarioperator1723725730.jpg",
        review: "1 Reviwes",
        features: [
            { icon: "fa-solid fa-star", icon1: "fa-solid fa-star", icon2: "fa-solid fa-star", icon3: "fa-solid fa-star", icon4: "fa-solid fa-star" },
            
        ],
        footerfeatures: [
           { number: "13",  text: "Parks" },
           { number: "0", text: "Packages" },
           { number: "0", text: "Shared Safari" },
        ],
    },
    {
        id: 4,
        title: "Tiger Safari India",
        image: "https://www.walkintothewild.in/storage/safarioperator/31/safarioperator1723659277.jpg",
        review: "0 Reviwes",
        features: [
            { icon: "fa-solid fa-star", icon1: "fa-solid fa-star", icon2: "fa-solid fa-star", icon3: "fa-solid fa-star", icon4: "fa-solid fa-star" },
            
        ],
        footerfeatures: [
           { number: "5",  text: "Parks" },
           { number: "0", text: "Packages" },
           { number: "0", text: "Shared Safari" },
        ],
    },
    {
        id: 5,
        title: "Wild India Safari",
        image: "https://www.walkintothewild.in/storage/safarioperator/80/safarioperator1725213503.jpg",
        review: "0 Reviwes",
        features: [
            { icon: "fa-solid fa-star", icon1: "fa-solid fa-star", icon2: "fa-solid fa-star", icon3: "fa-solid fa-star", icon4: "fa-solid fa-star" },
            
        ],
        footerfeatures: [
           { number: "11",  text: "Parks" },
           { number: "3", text: "Packages" },
           { number: "0", text: "Shared Safari" },
        ],
    },
];

export default Operators;
